import { css } from '@linaria/core'

const styles = css`
  @apply w-full h-full;
`

export default styles
